import { notifyAvatarCacheBustersChanged } from "./avatarCacheBusterStore";
import { AVATAR_CACHE_BUSTER_PREFIX, type AvatarEntityType } from "./avatarEntityTypes";

export function readAvatarCacheBuster(entityType: AvatarEntityType, entityId: string): string | undefined {
  return localStorage.getItem(`${AVATAR_CACHE_BUSTER_PREFIX[entityType]}${entityId}`) ?? undefined;
}

export function writeAvatarCacheBuster(
  entityType: AvatarEntityType,
  entityId: string,
  timestamp: number | string,
): void {
  localStorage.setItem(`${AVATAR_CACHE_BUSTER_PREFIX[entityType]}${entityId}`, String(timestamp));
  notifyAvatarCacheBustersChanged();
}

export function withAvatarCacheBust(
  entityType: AvatarEntityType,
  avatarUri: string,
  entityId: string,
  timestamp?: number | string,
): string {
  const cacheBuster = timestamp ?? readAvatarCacheBuster(entityType, entityId);
  if (!cacheBuster) {
    return avatarUri;
  }

  const url = new URL(avatarUri);
  url.searchParams.set("t", String(cacheBuster));
  return url.toString();
}
